import React from "react";

const DashboardPrograms = ({ stats }) => {
  const topPrograms = stats?.topPrograms || [];

  return (
    <div
      className="p-4 rounded-4 h-100 d-flex flex-column justify-content-center"
      style={{
        background: "linear-gradient( #f7a1e4 0%, #826af6 100%)",
        color: "#fff",
      }}
    >
      <div className="lato-bold-20 mb-2">Top 3 sessions this week:</div>
      {topPrograms.length > 0 ? (
        topPrograms.map((program, index) => (
          <div key={index} className="lato-bold-20" style={{ color: "#fff" }}>
            {program._id} ({program.count})
          </div>
        ))
      ) : (
        <div className="lato-medium-16">No sessions data available</div>
      )}
    </div>
  );
};

export default DashboardPrograms;
